
import type { PropType } from 'vue'
import { defineComponent, ref } from 'vue'

import useTooltip from '@/modern/composable/useTooltip'
import useClickOutside from '@/modern/composable/useClickOutside'

type Column = {
    key: string
    name: string
}

export default defineComponent({
    props: {
        columns: {
            type: Array as PropType<Column[]>,
            default: () => []
        },
        modelValue: {
            type: Array as PropType<Column[]>,
            default: () => []
        },
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const container = ref<HTMLElement | null>(null)

        const { reference, tooltip, isVisible, x, y, strategy, open, close } = useTooltip({
            placement: 'left-start',
            strategy: 'absolute',
            offset: 12,
            autoPlacement: {
                allowedPlacements: ['bottom', 'top', 'left-start', 'left-end'],
            },
        })

        useClickOutside(container, close)

        const updateValue = (newValue: Column[]) => {
            emit('update:modelValue', newValue)
        }

        const isColumnDisplayed = (column: Column) => {
            if (props.modelValue.some((c) => c.key === column.key)) {
                return true
            }

            return false
        }

        const toggleColumn = (column: Column) => {
            if (isColumnDisplayed(column)) {
                const copy = [...props.modelValue]

                const index = copy.findIndex((c) => c.key === column.key)
                copy.splice(index, 1)
                
                updateValue(copy)
                return
            }

            const copy = props.columns.filter((c) => props.modelValue.some((mc) => mc.key === c.key) || c.key === column.key)
            updateValue(copy)
        }
        
        return {
            container,
            reference,
            tooltip,
            isVisible,
            x,
            y,
            strategy,
            open,
            close,
            isColumnDisplayed,
            toggleColumn
        }
    }
})
